
let _pauseHttpOperations = false;

export default class HttpController {

  static queue = [];

  static enqueue(op) {
    HttpController.queue.push(op);
  }

  static get pauseHttpOperations() {
    return _pauseHttpOperations;
  }

  static set pauseHttpOperations(value) {
    _pauseHttpOperations = value;
    if (!value) {
      HttpController.emptyQueue();
    }
  }

  static emptyQueue() {
    HttpController._dequeueAndRun();
  }

  static _dequeueAndRun() {
    if (HttpController.queue.length === 0) {
      return;
    }

    const run = HttpController.queue.shift();
    if (!run) {
      return;
    }

    run()
      .then(res => {
        HttpController._dequeueAndRun();
        return res;
      })
      .catch(err => {
        HttpController._dequeueAndRun();
        return Promise.reject(err);
      });
  }
}